import { useState } from 'react';

const API = process.env.REACT_APP_API_URL || '';

/* Sign-in for athlete accounts: a username and a password. It is separate from
   the main application's sign-in, which it does not change. On success the
   session token is stored exactly as the main sign-in stores it, and the app
   reloads into the athlete's Recruiting Center. */
export default function AthleteSignIn() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError('');
    if (!username.trim() || !password) { setError('Enter your username and password.'); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/recruiting/login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim(), password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Sign-in failed. Try again.');
      localStorage.setItem('token', data.token);
      window.location.replace('/');
    } catch (x) { setError(x.message); setLoading(false); }
  };

  const field = 'w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent';
  return (
    <div className="min-h-screen bg-[#0A0E27] flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/SchemeSync_Logo.png" alt="SchemeSync HS" className="mx-auto mb-4 h-20 w-auto" />
          <h1 className="text-2xl font-bold text-white">Recruiting Center</h1>
          <p className="text-gray-400 mt-1 text-sm">Athlete sign-in</p>
        </div>
        <div className="bg-gray-800 rounded-xl shadow-2xl p-6 sm:p-8 border border-gray-700">
          {error && <div className="bg-red-900/50 border border-red-700 text-red-300 px-4 py-3 rounded-lg mb-4 text-sm">{error}</div>}
          <form onSubmit={submit} noValidate className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-1" htmlFor="athlete-username">Username</label>
              <input id="athlete-username" type="text" value={username} onChange={(e) => setUsername(e.target.value)} className={field}
                autoComplete="username" autoCapitalize="none" autoCorrect="off" spellCheck={false} placeholder="Your username" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-1" htmlFor="athlete-password">Password</label>
              <input id="athlete-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={field}
                autoComplete="current-password" placeholder="Your password" />
            </div>
            <button type="submit" disabled={loading}
              className="w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-800 disabled:cursor-not-allowed text-white font-semibold rounded-lg transition-colors duration-200">
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
        <p className="text-center text-gray-500 text-xs mt-6">Coaches and staff sign in at <a className="underline" href="/">the main sign-in page</a>.</p>
      </div>
    </div>
  );
}
